import React from "react";

import Heading from "../../typography/Heading";
import Text from "../../typography/Text";

import "./ContentPanelHeader.css";

export default function ContentPanelHeader({
  title,
  subTitle,
  children,
  className = "",
}) {
  if (!title && !subTitle && !children) return null;

  return (
    <div className={`content-panel-header ${className}`.trim()}>
      <div className="content-panel-header__info">
        {title && (
          <Heading as="h2" size="md">
            {title}
          </Heading>
        )}

        {subTitle && (
          <Text as="p" tone="secondary" size="sm">
            {subTitle}
          </Text>
        )}
      </div>

      {children && (
        <div className="content-panel-header__actions">{children}</div>
      )}
    </div>
  );
}
